module.exports = __webpack_public_path__ + "static/media/create-icon.55d7b11b.svg";